// extracted by mini-css-extract-plugin
module.exports = {"root":"quickbooks_root__JwlfN","infoBtn":"quickbooks_infoBtn__2vPUc","formBox":"quickbooks_formBox__1HrL-","formFooter":"quickbooks_formFooter__2CBfk"};